import React from "react";
import "./App.css";
import { TrialForm } from "./TrialForm";
import { FormStore } from "./FormStore";
import { AdminApp } from "./AdminApp";
import { initializeIcons } from "@fluentui/react";
import { BrowserRouter, Route, Routes } from "react-router-dom";

const formStore = new FormStore();

initializeIcons();

export const App: React.FunctionComponent = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/admin/*" element={<AdminApp />} />
        <Route path="/" element={<TrialForm store={formStore} />} />
      </Routes>
    </BrowserRouter>
  );
};
